export default __webpack_public_path__ + "media/images/react_icons/success-square-4778a08f120de521d56e74b8fa41c778.svg";